"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectHowToPayForProjectCard = void 0;
const PlayerInputTypes_1 = require("../PlayerInputTypes");
const Units_1 = require("../Units");
const MoonExpansion_1 = require("../moon/MoonExpansion");
const CardName_1 = require("../CardName");
class SelectHowToPayForProjectCard {
    constructor(player, cards, cb) {
        this.cards = cards;
        this.cb = cb;
        this.inputType = PlayerInputTypes_1.PlayerInputTypes.SELECT_HOW_TO_PAY_FOR_PROJECT_CARD;
        this.title = 'Play project card';
        this.buttonLabel = 'Play card';
        this.microbes = player.getMicrobesCanSpend();
        this.floaters = player.getFloatersCanSpend();
        this.canUseHeat = player.canUseHeatAsMegaCredits;
        this.canUsePlants = player.cardIsInEffect(CardName_1.CardName.MARTIAN_LUMBER_CORP);
        this.scienceResources = player.getSpendableScienceResources();
        this.asteroidResources = player.getSpendableAsteroidResources();
        this.spireScienceResources = player.getSpendableSpireScienceResources();
        this.grapheneResources = player.getSpendableGrapheneResources();
        this.reserveUnits = this.cards.map((card) => {
            return card.reserveUnits ? MoonExpansion_1.MoonExpansion.adjustedReserveCosts(player, card) : Units_1.Units.EMPTY;
        });
    }
}
exports.SelectHowToPayForProjectCard = SelectHowToPayForProjectCard;
//# sourceMappingURL=SelectHowToPayForProjectCard.js.map